export default "__VITE_ASSET__kGioInf1__"